<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page edit-massive-invoice">
    <div class="formgrid grid mt-5 card">
        <div class="field col-12 md:col-6">
            <label>Data Emissione</label>
            <Calendar v-model="data_emissione"  dateFormat="dd-mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_emissione || validationErrors.data_before && submitted}]"  />
            <div v-show="validationErrors.data_emissione && submitted" class="p-error">Data non valida.</div>
            <div v-show="validationErrors.data_before && submitted" class="p-error">Data emissione non può essere successiva alla scadenza.</div>
        </div>
        <div class="field col-12 md:col-6">
            <label>Data Scadenza</label>
            <Calendar v-model="data_scadenza" dateFormat="dd-mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_scadenza && submitted}]"  />
            <div v-show="validationErrors.data_scadenza && submitted" class="p-error">Data non valida.</div>
        </div>
    </div>

    <small v-if="itemsNotEditable.length > 0" class="p-error m-2 block">
      Alcune fatture non sono modificabili perchè già inviate allo SDI
    </small>

    <DataTable :value="items" responsiveLayout="scroll" v-model:selection="selectedItems" :filters="filters" :rowClass="rowClass">
      <template #header>
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center mb-2">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
              </span>
            </div>
            <div v-if="items?.length > 0" class="flex align-items-center justify-content-center">
              Selezionati {{selectedItems.length}} / {{items.length}} 
            </div>
        </div>
      </template>
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template>
      <Column selectionMode="multiple" />
      <Column field="numero" header="Numero"></Column>
      <Column field="ragsoc" header="Cliente"></Column>
      <Column field="data_emissione" header="Data Emissione" :sortable="true">
        <template #body="{data}">
          {{formatDate(data.data_emissione)}}     
        </template>
      </Column>
      <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
        <template #body="{data}">
          {{formatDate(data.data_scadenza)}}     
        </template>
      </Column>
      <Column field="totale_fattura" header="Tot.Fattura" :sortable="true">
        <template #body="{data}">
          {{data.totale_fattura.toFixed(2)}}
        </template>
      </Column>
      <Column field="pregressivoSDI" header="SDI" :sortable="true">
        <template #body="{data}">
          {{data.pregressivoSDI == 0 ? 'NON INVIATO' : 'INVIATO'}}
        </template>
      </Column>
    </DataTable>
      
      <div v-if="itemsNotEditable.length > 0" class="mt-3">
        <Accordion>
          <AccordionTab header="Non Modificabili">
            <DataTable :value="itemsNotEditable" responsiveLayout="scroll">
              <Column field="numero" header="Numero"></Column>
              <Column field="ragsoc" header="Cliente"></Column>
              <Column field="data_emissione" header="Data Emissione" :sortable="true">
                <template #body="{data}">
                  {{formatDate(data.data_emissione)}}     
                </template>
              </Column>
              <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
                <template #body="{data}">
                  {{formatDate(data.data_scadenza)}}     
                </template>
              </Column>
              <Column field="totale_fattura" header="Tot.Fattura" :sortable="true">
                <template #body="{data}">
                  {{data.totale_fattura.toFixed(2)}}
                </template>
              </Column>
              <Column field="pregressivoSDI" header="SDI" :sortable="true">
                <template #body="{data}">
                  {{data.pregressivoSDI == 0 ? 'NON INVIATO' : 'INVIATO'}}
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>

  </div>

  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import moment from 'moment'
import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";


export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'fattura-modifica-massiva-dati'}
    const loader = ref(false)
    const toast = useToast();
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const items = ref(props.data)
    const itemsNotEditable = ref([])
    const selectedItems = ref([])
    const data_emissione = ref(new Date())
    const data_scadenza = ref(new Date())
    const validationErrors = ref({})
    const submitted = ref(false)

    onMounted(() =>{
      itemsNotEditable.value = items.value.filter((el) => el.pregressivoSDI != 0)
      items.value = items.value.filter((el) => el.pregressivoSDI == 0)
    })

    
    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);

      if (selectedItems.value.length > 0) {
        if (!checkSameDate()) {
          toast.add({severity:'warn', summary: 'Attenzione', detail: 'Fatture selezionate hanno date emissione diverse', group: page.name});
          return
        }
        if (validateForm()) {
          loader.value = true
          let emissione = moment(data_emissione.value).format("YYYY-MM-DD")
          let scadenza = moment(data_scadenza.value).format("YYYY-MM-DD")
          service.editInvoices(selectedItems.value, emissione, scadenza)
          .then((res) =>{
            if (res.item.success) {
              toast.add({severity:'success', summary: 'Successo', detail: res.item.msg, group: page.name});
              selectedItems.value.map((el) => {
                el.data_emissione =  emissione
                el.data_scadenza =  scadenza
              })
              self.$eventBus.emit('update-tab-fattureClientiDataTable', selectedItems.value)
            } else {
              toast.add({severity:'warn', summary: 'Attenzione', detail:res.item.msg, group: page.name});
            }

          })
          .finally(()=>{
            loader.value = false
          })
        }
      } else {
        toast.add({severity:'warn', summary: 'Attenzione', detail: 'Nessuna fattura selezionata', group: page.name});
      }
    }

    const checkSameDate = () => {
      let dates = []
      selectedItems.value.forEach(el => {
        if (!dates.includes(el.data_emissione)) {
          dates.push(el.data_emissione)
        }
      });
      return dates.length > 1 ? false: true 
    }


    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }



    const rowClass = (data) => {
      return data.pregressivoSDI != 0 ? 'row-error': null;
    };



    const validateForm = () => {

      if (data_emissione.value != null && moment(data_emissione.value).isValid()) {
        delete validationErrors.value['data_emissione'];
      } else {
        validationErrors.value['data_emissione'] = true;
      }

      if (data_scadenza.value != null && moment(data_scadenza.value).isValid()) {
        delete validationErrors.value['data_scadenza'];
      } else {
        validationErrors.value['data_scadenza'] = true;
      }

      if (moment(data_emissione.value).isValid() && moment(data_scadenza.value).isValid()) {
        if(moment(data_emissione.value).isBefore(moment(data_scadenza.value))){
          delete validationErrors.value['data_before'];
        } else {
          validationErrors.value['data_before'] = true;
        }
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      items,
      itemsNotEditable,
      selectedItems,
      data_emissione,
      data_scadenza,
      loader,
      onCancelButton,
      onOkButton,
      formatDate,
      filters,
      rowClass,
      submitted,
      validationErrors
    }
  }
}


</script>

<style scoped>
.message {
  margin-top: 30px;
  margin-top: 10px;
  background-color: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
}
.message .link {
    color: #2ca9f3;
}
:deep(.row-error) {
    background-color: rgba(255, 152, 152, 0.423) !important;
}
</style>

<style>
.edit-massive-invoice .card {
  background-color: #e3f2fd !important;
  position: sticky;
  top: 0px;
  z-index: 2000;
}
/* .edit-massive-invoice .p-datatable-header {
  
} */
</style>
